/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamVisualizationQuestionViewModel } from "../types/BotExamVisualizationQuestionViewModel.ts";
import { botExamVisualizationOptionViewModelSchema } from "./botExamVisualizationOptionViewModelSchema.ts";
import { botExamVisualizationTranslationViewModelSchema } from "./botExamVisualizationTranslationViewModelSchema.ts";

export const botExamVisualizationQuestionViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da questão em pt-BR.")),
  type: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo da questão gerada pelo bot. Enum EBotExamType: `1` = Default, `2` = TrueFalse, `3` = MultipleAffirmations, `4` = FillInTheBlanks.",
      ),
  ),
  label: z
    .string()
    .describe(
      "Enunciado da questão decodificado (HTML entities convertidas). Opcional.",
    )
    .nullish(),
  transcriptExcerpt: z
    .string()
    .describe(
      "Trecho da transcrição de aula utilizado como base para geração da questão. Opcional.",
    )
    .nullish(),
  explanation: z
    .string()
    .describe("Explicação da resposta correta decodificada. Opcional.")
    .nullish(),
  options: z
    .array(z.lazy(() => botExamVisualizationOptionViewModelSchema))
    .describe("Alternativas da questão em pt-BR, ordenadas por ID.")
    .nullish(),
  translations: z
    .array(z.lazy(() => botExamVisualizationTranslationViewModelSchema))
    .describe(
      "Versões traduzidas desta questão para os demais idiomas cadastrados (ex: en-US, es-ES), casadas por índice posicional com a questão pt-BR.",
    )
    .nullish(),
}) as unknown as ToZod<BotExamVisualizationQuestionViewModel>;
